/* eslint-disable @typescript-eslint/no-explicit-any */
import { ExtendedColumnDef } from "components/Datatable";
import { ILateColumns } from "src/@types/late-conciliation";
import styled from "styled-components";
import SortedCell from "./components/sorted-cell";
import { useNavigate } from "react-router-dom";

export const useColumns = () => {
  const navigate = useNavigate();

  const columns: ExtendedColumnDef<ILateColumns>[] = [
    {
      accessorKey: "code",
      header: ({ column }) => (
        <SortedCell column={column} title={"Lojas"} orderName="code" />
      ),
      cell: ({ row }) => <div>{`Loja ${row?.original?.code}`}</div>,
      className: "store-column",
    },
    {
      accessorKey: "responsible.name",
      header: ({ column }) => (
        <SortedCell
          column={column}
          title={"Analista"}
          orderName="responsible"
        />
      ),
      className: "reponsible-column",
    },
    {
      accessorKey: "totalDivergenceAmount",
      header: "Valor total",
      cell: ({ row }) => (
        <div className="text-center">
          R$ {(row.original.totalDivergenceAmount ?? 0).toFixed(2)}
        </div>
      ),
      className: "returns-column",
    },
    {
      accessorKey: "store.regional.id",
      header: "Regional",
      cell: ({ row }) => `${row?.original?.regional?.name || ""}`,
      className: "region-column",
    },
    {
      accessorKey: "totalDivergenceCount",
      header: "Divergências Atrasadas",
      cell: ({ row }) => (
        <div className="text-center">{row.original.totalDivergenceCount ?? 0}</div>
      ),
      className: "deposit-column",
    },
    {
      id: "actions",
      header: () => <div> Ações </div>,
      cell: ({ row }) => {
        const store = row.original;

        return (
          <ActionCell>
            <button
              onClick={() =>
                navigate(
                  `/conciliacao/faltas-de-conciliacoes?code=${store.code}`
                )
              }
            >
              {" "}
              Ver mais
            </button>
          </ActionCell>
        );
      },
      className: "actions-column",
    },
  ];
  return columns;
};

const ActionCell = styled.div<{ noAction?: boolean }>`
  width: max-content;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 10px;
  ${({ noAction }) => (noAction ? "background: #E9E9EF;" : "")}
  button {
    border: none;
    background: transparent;
    color: #5577b9;
    text-decoration: underline;
    width: fit-content;
    padding: 0;

    &:hover {
      filter: brightness(0.65);
    }
  }
`;
